/**
 * The one SVG frame every pictogram in the product is drawn in.
 *
 * §10 of the brand sheet fixes the icon language and it is not the friendly
 * rounded one most apps ship: CHROME AND STEEL, HARD EDGES. So the frame sets
 * square caps and mitred joins, and a glyph drawn here comes out looking
 * machined rather than hand-lettered. That is a decision about the whole set,
 * which is exactly why it lives in the frame and not in eleven `<path>` files.
 *
 * `fill="none"` with a `currentColor` stroke is what lets a caller tint a glyph
 * and its label from a single token — an idle tab and its active state are one
 * `color` change, not two icon variants.
 *
 * `aria-hidden`, ALWAYS. Every glyph in this product ships beside its own text
 * label, or inside a control that carries an `aria-label`, and none of them is
 * ever the only carrier of a fact (NFR-04). A glyph that needed announcing
 * would be a design bug upstream of this file.
 */
export default function Icon({ children, size = 24, ...rest }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            /* Heavier than the sibling product's 1.5. These glyphs sit on
               near-black, where a hairline stroke reads as grey rather than as
               metal, and they are as often over artwork as over a plate. */
            strokeWidth="1.75"
            strokeLinecap="square"
            strokeLinejoin="miter"
            aria-hidden="true"
            focusable="false"
            {...rest}
        >
            {children}
        </svg>
    );
}
